module.exports = __webpack_public_path__ + "ca21d4a756895b58893b56fb039211c6.svg";